import type { ReactNode } from "react"
import { Icon, type IconName } from "./icons.tsx"

export function Card({
  children,
  padded = true,
  tone,
  className,
}: {
  children: ReactNode
  /** false 면 본문이 가장자리까지 간다 — 표를 통째로 담을 때. */
  padded?: boolean
  tone?: "accent" | "danger" | "warn"
  /** 화면이 이 카드 하나만 집어 손볼 때(예: 스캔 중 숨기기). */
  className?: string
}) {
  const classes = ["card"]
  if (!padded) classes.push("card--flush")
  if (tone) classes.push(`card--${tone}`)
  if (className) classes.push(className)
  return <div className={classes.join(" ")}>{children}</div>
}

/** 카드 머리 — 제목(+아이콘·설명)과 우측 액션. */
export function CardHeader({
  title,
  description,
  icon,
  actions,
}: {
  title: ReactNode
  description?: ReactNode
  icon?: IconName
  actions?: ReactNode
}) {
  return (
    <div className="card__head">
      <div className="card__heading">
        {icon ? <Icon name={icon} size={16} className="card__icon" /> : null}
        <h2 className="card__title">{title}</h2>
      </div>
      {actions ? <div className="card__actions">{actions}</div> : null}
      {description ? <p className="card__desc">{description}</p> : null}
    </div>
  )
}

export function CardBody({ children }: { children: ReactNode }) {
  return <div className="card__body">{children}</div>
}

export function CardFooter({ children }: { children: ReactNode }) {
  return <div className="card__foot">{children}</div>
}

/** 카드 안의 소구획. 제목 한 줄 + 본문. */
export function Section({
  title,
  actions,
  children,
}: {
  title: ReactNode
  actions?: ReactNode
  children: ReactNode
}) {
  return (
    <section className="section">
      <div className="section__head">
        <h3 className="section__title">{title}</h3>
        {actions ? <div className="section__actions">{actions}</div> : null}
      </div>
      {children}
    </section>
  )
}

/** 화면 머리 — 제목·설명·우측 주요 액션. */
export function PageHeader({
  title,
  description,
  actions,
  above,
  meta,
}: {
  title: ReactNode
  description?: ReactNode
  actions?: ReactNode
  /** 제목 위 줄 — 뒤로가기 링크 등. */
  above?: ReactNode
  /** 제목 아래 요약 — "전체 7 · 미입고 2" 처럼 지금 상황을 숫자로 한 줄. */
  meta?: ReactNode
}) {
  return (
    <header className="page-head">
      <div className="page-head__text">
        {above ? <div className="page-head__above">{above}</div> : null}
        <h1 className="page-head__title">{title}</h1>
        {description ? <p className="page-head__desc">{description}</p> : null}
        {meta ? <div className="page-head__meta">{meta}</div> : null}
      </div>
      {actions ? <div className="page-head__actions">{actions}</div> : null}
    </header>
  )
}
